<template>
	<h-tab v-slot="{selected}" as="template">
		<button
			type="button"
			class="ring-focus mt-1 border-b-2 pt-2 pb-4 text-base whitespace-nowrap outline-hidden"
			:class="{
				'border-b-black font-bold text-black': selected,
				'border-b-transparent text-gray-500 hover:border-b-black/20 focus:border-black/20':
					!selected,
			}"
			v-bind="$attrs"
		>
			<slot></slot>
		</button>
	</h-tab>
</template>

<script setup lang="ts">
defineOptions({
	inheritAttrs: false,
});
</script>
